import { colorPalette100, header, host } from "./globalVariables";
import { api } from "./pureFunctions";

export async function getKacheln() {
   const responseEstateKacheln = await api.get("/api/getKacheln").then((data) => {
      console.log(data);

      return data.data;
   });
   return responseEstateKacheln;
}

export async function sendMail(estateId, mailSubject, mailContent, receiver, setMailStatus, file) {
   setMailStatus("loading");

   console.log(mailContent);

   const oOReceiver = receiver
      .filter((item) => item.id)
      .map((item) => ({ addressid: "" + item.id, email: item.email }));
   const otherReceiver = receiver.filter((item) => !item.id).map((item) => item.email);

   if (oOReceiver.length > 0) {
      let mailData = {
         emailidentity: "info@baur-immobilien.de",
         displayName: "Baur Immobilien",
         useHtml: true,
         receiver: oOReceiver,
         estateids: [estateId],
         body: mailContent,
         subject: mailSubject,
         signatureid: 0,
         handleReceiversSeparately: true,
         ...(file
            ? {
                 attachmentsDirectData: { [file.name]: file.content },
              }
            : {}),
      };
      console.log(mailData);

      await api
         .post("/api/sendEmail", mailData, header)
         .then((data) => {
            console.log(data);
            setMailStatus("success");
         })
         .catch((err) => {
            setMailStatus("error");
            console.log(err);
            console.error({
               error: "onOffice",
               message: err,
            });
         });
   }

   if (otherReceiver.length > 0) {
      let mailData = {
         emailidentity: "info@baur-immobilien.de",
         displayName: "Baur Immobilien",
         useHtml: true,
         receiver: ["info@baur-immobilien.de"],
         estateids: [estateId],
         body: mailContent,
         subject: mailSubject,
         signatureid: 0,
         // receiver: otherReceiver,
         bcc: otherReceiver,
         // handleReceiversSeparately: true,
         ...(file
            ? {
                 attachmentsDirectData: { [file.name]: file.content },
              }
            : {}),
      };
      console.log(mailData);

      await api
         .post("/api/sendEmail", mailData, header)
         .then((data) => {
            console.log(data);
            setMailStatus("success");
         })
         .catch((err) => {
            setMailStatus("error");
            console.log(err);
            console.error({
               error: "onOffice",
               message: err,
            });
         });
   }
}

export async function renameDbxItem(oldPath, newPath) {
   try {
      await api.post("/api/dropbox/rename", { oldPath, newPath }, header).then((data) => {
         console.log(data);
      });

      return newPath;
   } catch (error) {
      window.alert(`Fehler beim Umbenennen.\n${JSON.stringify(error, null, 2)}`);
      console.log(error);
      return oldPath;
   }
}

export async function checkItem(path) {
   try {
      await api.post("/api/dropbox/exists", { path }, header).then((data) => {
         console.log(data);
      });

      return path;
   } catch (error) {
      throw error;
   }
}

export async function getCleanUsers() {
   const cleanUserData = await api
      .get("/api/getusers")
      .then((data) => {
         console.log(data);

         const allUserData = data.data.data
            .filter(
               (user) =>
                  // (user.elements.online === "online" || user.elements.online === "offline") &&
                  user.elements.Kuerzel && user.elements.Nachname != "Dummy",
            )
            .map((useItem, index) => {
               return {
                  ...useItem.elements,
                  active: useItem.elements.online === "online" || useItem.elements.online === "offline",
                  color: colorPalette100[index % 100],
               };
            });
         console.log(allUserData);

         return {
            archivedUserList: allUserData,
            user: data.data.username,
            userList: allUserData.filter((item) => item.active),
            userObject: allUserData.reduce((oldObj, item) => ({ ...oldObj, [item.id]: item }), {}),
         };
      })
      .catch((err) => {
         console.log(JSON.stringify(err.response.data, null, 1));
      });
   return cleanUserData;
}

export async function getOOUserData(myUsername) {
   const myFullUser = await getCleanUsers().then((data) => {
      console.log(data);
      console.log(myUsername);

      const loggedinuser = data.userList.filter((user) => user.Name === myUsername);
      console.log(loggedinuser);

      if (loggedinuser.length) {
         let myuser = loggedinuser[0];
         return myuser;
      } else {
         return false;
      }
   });
   return myFullUser;
}

export async function goToOOAddress(myAddressId) {
   await api
      .post("/api/getOoLink", { id: myAddressId, resourcetype: "address" })
      .then((estateooLink) => {
         console.log(estateooLink.data.url);
         window.open(estateooLink.data.url, "_blank");
      })
      .catch((err) => {
         console.log(JSON.stringify(err.response.data, null, 1));
      });
}

export async function getAppointments(parameters) {
   let terminResponse = await api
      .post("/api/readTermine", parameters)
      .then((resp_data) => {
         let newTerminresponse = resp_data.data
            ? resp_data.data
                 .filter((item) => item.elements.users.length)
                 .map((item) => {
                    return { terminId: item.id, ...item };
                 })
            : [];
         console.log(newTerminresponse);
         return newTerminresponse;
      })
      .catch((err) => {
         console.log("Termine");

         console.log(err);
      });
   return terminResponse;
}

export async function getAppointmentsWithLocations(parameters) {
   let terminResponse = await api
      .post("/api/readTermine", parameters)
      .then((resp_data) => {
         let newTerminresponse = resp_data.data
            ? resp_data.data
                 .filter((item) => item.elements.users.length)
                 .map((item) => {
                    return { terminId: item.id, ...item };
                 })
            : [];
         console.log(newTerminresponse);
         return newTerminresponse;
      })
      .catch((err) => {
         console.log("Termine");

         console.log(err);
      });

   const estateTermine = terminResponse
      .filter((item) => item.elements.location && item.elements.location.type === "estate")
      .map((item) => ({
         type: item.elements.type,
         terminId: item.id,
         datum: new Date(item.elements.date.start),
         location: item.elements.location ? item.elements.location : "",
         benutzer: item.elements.users ? item.elements.users : [],
         contacts: item.elements.contacts ? item.elements.contacts : [],
         subject: item.elements.subject,
         estateId: item.elements.estate ? item.elements.estate.id : "",
      }));

   const addressTermine = terminResponse
      .filter((item) => item.elements.location && item.elements.location.type === "address")
      .map((item) => ({
         type: item.elements.type,
         terminId: item.id,
         datum: new Date(item.elements.date.start),
         location: item.elements.location ? item.elements.location : "",
         benutzer: item.elements.users && item.elements.users.length ? item.elements.users : [],
         contacts: item.elements.contacts && item.elements.contacts.length ? item.elements.contacts : [],
         subject: item.elements.subject,
         addressId: item.elements.contacts && item.elements.contacts.length ? item.elements.contacts[0].id : "",
      }));

   const estateLocationParameters = {
      data: ["strasse", "hausnummer", "plz", "ort", "objektnr_extern", "objekttitel", "breitengrad", "laengengrad"],
      filter: {
         Id: [{ op: "IN", val: estateTermine.map((item) => item.estateId) }],
      },
      listlimit: 500,
      sortby: { objektnr_extern: "DESC" },
   };
   console.log(estateLocationParameters);

   const estateData = await api
      .post("/api/readEstates", { parameters: estateLocationParameters })
      .then((resp_data) => {
         console.log(resp_data.data);

         return resp_data.data.reduce((oldObj, item) => ({ ...oldObj, [item.id]: item.elements }), {});
      })
      .catch((err) => {
         console.log("readTerminOrt");
         console.log(err);
      });

   const addressLocationParameters = {
      data: ["Strasse", "Plz-Ort", "breitengrad", "laengengrad"],
      filter: {
         ID: [{ op: "IN", val: addressTermine.map((item) => item.addressId) }],
      },
      listlimit: 500,
      sortby: { KdNr: "DESC" },
   };
   console.log(addressLocationParameters);
   const addressData = await api
      .post("/api/getfilteredaddresses", { parameters: addressLocationParameters })
      .then((resp_data) => {
         console.log(resp_data.data);

         return resp_data.data.reduce((oldObj, item) => ({ ...oldObj, [item.id]: item.elements }), {});
      })
      .catch((err) => {
         console.log("readTerminOrt");
         console.log(err);
      });

   let fullDataTermin = estateTermine.map((item) => ({ ...item, ...estateData[item.estateId] }));
   fullDataTermin.push(...addressTermine.map((item) => ({ ...item, ...addressData[item.addressId] })));
   let newAvailableUsers = fullDataTermin.reduce((oldObj, item) => ({ ...oldObj, [item.benutzer[0].id]: true }), {});

   return [terminResponse, fullDataTermin, newAvailableUsers];
}

export async function changeoOEstate(url, dataItem, setLoading) {
   setLoading(true);
   const httpResponse = await api
      .post(host + url, dataItem, header)
      .then((respData) => {
         setLoading("success");
         console.log(respData);

         setTimeout(() => {
            setLoading(false);
         }, 1100);
         return respData;
      })
      .catch((err) => {
         console.log(err);
         /* setErrorMessage({
            error: "onOffice",
            message: `Fehlerurl: ${url}<br/>` + JSON.stringify(err.response.data, null, 1),
         }); */
         setLoading("error");
      });

   return httpResponse;
}

function debounce(fn, delay) {
   let timeoutId;
   return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => fn(...args), delay);
   };
}
const debouncetime = 1000;

export const debouncedSaveEstateData = debounce((value, estateId) => {
   saveEstateData(value, estateId);
}, debouncetime);

export async function saveEstateData(data, estateId) {
   const savedResponse = await api
      .post("/api/ip/estateData", { estateId: estateId, ...data }, header)
      .then((data) => {
         console.log("saved Data");
         console.log(data);
         return data.data;
      })
      .catch((err) => {
         console.log(err);
      });
   return savedResponse;
}

export async function getEstateData(estateId, fieldNames) {
   const data = await api.get(`api/ip/estateData`, {
      params: {
         estateId: estateId,
         reqData: fieldNames,
      },
      ...header,
   });
   console.log(data);
   return data.data;
}
